import { SVGProps, Ref, forwardRef } from 'react';

export const PlusCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5m-.702 11.164V8.698H4.332v-1.4h2.966V4.332h1.4v2.966h2.966v1.4H8.698v2.966z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PlusCircleFilledSize16Glyph.displayName = 'PlusCircleFilledSize16Glyph';
